import { createRootRoute, Outlet } from '@tanstack/react-router';
import { ErrorBoundary } from '../components/error-boundary';

/**
 * Root layout — wraps every route.
 * - ErrorBoundary catches React render errors.
 * - ToastContainer (T27) wires global toast notifications from `api-error` events.
 * - GlobalNotificationsListener (Faza 6) listens dla in-app notifications.
 */
export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  return (
    <ErrorBoundary>
      <Outlet />
    </ErrorBoundary>
  );
}
